import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';

import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Mohon isi alamat email dan kata sandi');
      return;
    }

    setLoading(true);
    try {
      await login(email, password);
      toast.success('Login berhasil!');
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.detail || 'Email atau kata sandi salah');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="cemara-login">
      <div className="cemara-login-shell">
        <header className="cemara-login-brand">
          <img src="/logo-original.png" alt="Logo Kos Cemara" width="52" height="65" />
          <div><span className="cemara-login-name">Kos Cemara</span><p>Selamat datang di rumah Anda.</p></div>
        </header>
        <section className="cemara-login-card" aria-labelledby="login-heading">
          <div className="cemara-login-intro">
            <span className="cemara-login-eyebrow">AKUN KOS CEMARA</span>
            <h1 id="login-heading">Selamat datang</h1>
            <p>Masuk untuk mengakses informasi hunian dan layanan Kos Cemara.</p>
          </div>
            <form onSubmit={handleSubmit} className="space-y-5 mt-7">
              <div className="space-y-2">
                <Label htmlFor="email" className="text-sm font-medium">Alamat email</Label>
                <div className="relative">
                  <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
                  <Input
                    id="email"
                    type="email"
                    placeholder="Masukkan alamat email"
                    name="email" autoComplete="username" autoCapitalize="none" spellCheck={false} required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="cemara-login-input h-12 pl-12"
                    data-testid="login-email-input"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="password" className="text-sm font-medium">Kata sandi</Label>
                <div className="relative">
                  <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
                  <Input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Masukkan kata sandi"
                    name="password" autoComplete="current-password" required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="cemara-login-input h-12 pl-12 pr-12"
                    data-testid="login-password-input"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}
                    aria-pressed={showPassword}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                  </button>
                </div>
              </div>

              <Button
                type="submit"
                className="cemara-login-submit w-full h-12 font-medium text-base"
                disabled={loading}
                data-testid="login-submit-btn"
              >
                {loading ? (
                  'Sedang masuk…'
                ) : (
                  'Masuk ke akun'
                )}
              </Button>
            </form>

            <p className="cemara-login-register">
              Belum memiliki akun?{' '}
              <Link to="/register" className="text-primary font-medium hover:underline" data-testid="register-link">
                Daftar di sini
              </Link>
            </p>
        </section>
        <footer className="cemara-login-footer">
          <p>Butuh bantuan untuk masuk? <a href="mailto:koscemara22@gmail.com">Hubungi kami</a></p>
          <span>&copy; {new Date().getFullYear()} Kos Cemara. Semua hak dilindungi.</span>
        </footer>
      </div>
    </main>
  );
};

export default Login;
